import React, { useState, useEffect } from 'react';
import ReplayIcon from '@mui/icons-material/Replay';
import { Button, Box } from '@mui/material';
import GazeEye from './GazeEye';

export function GazeTrackView({ originalEyePositions }) {
  const [eyePositions, setEyePositions] = useState([]);
  const [currentEyePosition, setCurrentEyePosition] = useState({
    left: { x: 0, y: 0 },
    right: { x: 0, y: 0 },
  });
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    setEyePositions([...originalEyePositions]);
    animateEyePositions();
    return () => clearInterval(intervalId);
  }, []);

  const animateEyePositions = () => {
    if (intervalId) clearInterval(intervalId);
    
    const positions = [...originalEyePositions];
    const interval = 10000 / positions.length;

    const id = setInterval(() => {
      if (positions.length === 0) {
        clearInterval(id);
      } else {
        setCurrentEyePosition(positions.shift());
      }
    }, interval);
    setIntervalId(id);
  };

  const replayAnimation = () => {
    setCurrentEyePosition({ left: { x: 0, y: 0 }, right: { x: 0, y: 0 } });
    setEyePositions([...originalEyePositions]);
    animateEyePositions();
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box display="flex" justifyContent="space-between" width="100%">
         <GazeEye currentXPos={currentEyePosition.left.x} currentYPos={currentEyePosition.left.y} eye="Left"/>
         <GazeEye currentXPos={currentEyePosition.right.x} currentYPos={currentEyePosition.right.y} eye="Right"/>
      </Box>
      <Button onClick={replayAnimation} sx={{ mt: 2 }}>
        <ReplayIcon />
      </Button>
    </Box>
  );
}

export const eyePositions = [
  { left: { x: -0.20506482 }, right: { x: -0.13808306 } },
  { left: { x: 0.20501785 }, right: { x: -0.13802795 } },
  { left: { x: -0.2045 }, right: { x: -0.13747294 } },
  { left: { x: 0.233 }, right: { x: 0.188 } },
  { left: { x: 0.234 }, right: { x: 0.199 } },
  { left: { x: 0.256 }, right: { x: 0.211 } },
  { left: { x: 0.222 }, right: { x: 0.212 } },
  { left: { x: 0.181 }, right: { x: 0.161 } },
  { left: { x: 0.17 }, right: { x: 0.165 } },
  { left: { x: 0.0 }, right: { x: 0.0 } },
  { left: { x: 0.3 }, right: { x: 0.28 } },
];

export const eyePositionsCenter = [{ left: { x: 0.0 }, right: { x: 0.0 } }];
